import {Optional} from 'utility-types';
import {PlayerState} from '@common/player/state/player-state';
import {PlayerStoreOptions} from '@common/player/state/player-store-options';
import {IS_IOS} from '@ui/utils/platform';
import {canUseNativeAudioProvider} from '@common/player/utils/can-use-native-audio-provider';

export function initPlayerMediaSession(
  state: () => PlayerState,
  options: PlayerStoreOptions
) {
  if ('mediaSession' in navigator) {
    const runIfUnlocked = (action: () => void) => () => {
      if (
        state().controlsLocked ||
        (canUseNativeAudioProvider() && state().playbackEngine === 'native')
      ) {
        return;
      }
      action();
    };

    const actionHandlers: Optional<
      Record<MediaSessionAction, MediaSessionActionHandler>
    > = {
      play: runIfUnlocked(() => state().play()),
      pause: runIfUnlocked(() => state().pause()),
      previoustrack: runIfUnlocked(() => state().playPrevious(true, true)),
      nexttrack: runIfUnlocked(() => state().playNext(true, true)),
      stop: runIfUnlocked(() => state().stop()),
      seekto: details => {
        if (
          state().controlsLocked ||
          (canUseNativeAudioProvider() && state().playbackEngine === 'native')
        ) {
          return;
        }
        state().seek(details.seekTime || 0, true, true);
      },
      ...(IS_IOS
        ? {}
        : {
            seekbackward: runIfUnlocked(() =>
              state().seek(state().getCurrentTime() - 10, true, true),
            ),
            seekforward: runIfUnlocked(() =>
              state().seek(state().getCurrentTime() + 10, true, true),
            ),
          }),
    };
    for (const key in actionHandlers) {
      try {
        navigator.mediaSession.setActionHandler(
          key as MediaSessionAction,
          actionHandlers[key as MediaSessionAction]!
        );
      } catch (error) {}
    }
    const cuedMedia = state().cuedMedia;
    if (
      cuedMedia &&
      (!canUseNativeAudioProvider() || state().playbackEngine !== 'native')
    ) {
      options.setMediaSessionMetadata?.(cuedMedia);
    }
  }
}
